
const UIString = {

    'ko':{
        'INVALID_CORP_CODE_FORMAT':'기업 코드 형식에 오류가 있습니다.',
        'CORP_CODE_IS_REQUIRED':'기업 코드를 입력하시기 바랍니다.',
        'INVALID_EMAIL_FORMAT':'이메일 형식에 오류가 있습니다.',
        'EMAIL_IS_REQUIRED':'이메일을 입력하시기 바랍니다.',
        'PASSWORD_IS_REQUIRED':'패스워드를 입력하시기 바랍니다.',
        'INVALID_PASSWORD_FORMAT':'패스워드는 6자 이상, 40자 이하로 입력하시기 바랍니다.',
        'CORP_ADMIN_USER_LOGIN':'기업 회원 관리자 로그인',
        'CORP_CODE':'기업 코드',
        'EMAIL':'이메일',
        'PASSWORD':'패스워드',
        'LOGIN':'로그인',
        'FORGOT_PASSWORD':'패스워드를 잊으셨나요?',
        'FORGOT_CORP_CODE':'기업 코드를 잊으셨나요?',
        'CONFIRM':'확인',
        'PAGE_NOT_FOUND':'요청하신 페이지가 없습니다.',
        'UPDATED':'업데이트 되었습니다.',
        'UPDATE_FAILED': '업데이트 과정에서 에러가 발생하였습니다.',
        'NO_DATA': '데이터가 없습니다.',
        'SEARCH':'검색',
        'LIST':'LIST',

        'USERS':'Users',
        'CORPS':'Corps',

        // Nav title.
        'NAV_DASHBOARD':'Dashboard',
        'NAV_MOBILE_APP':'Mobile App',
        'NAV_LIST':'List',
        'NAV_DETAIL':'Detail',
        'NAV_NEW':'New',
        'NAV_UPDATE':'Update',
        'NAV_ADD':'Add',
        'NAV_USER':'User',
        'NAV_DETAIL':'Detail',
        'NAV_EDIT':'Edit',
        'NAV_CORP':'Corp',
        'NAV_USER_SIGNUP_REQUEST_LIST':'User Signup Request List',
        'NAV_CORP_SIGNUP_REQUEST_DETAIL':'Corp Signup Request Detail',
        'NAV_CORP_SIGNOUT_REQUEST_LIST':'Corp Signout Request List',
        'NAV_CORP_SIGNOUT_REQUEST_DETAIL':'Corp Signout Request Detail',
        'NAV_USER_SIGNOUT_REQUEST_LIST':'User Signout Request List',
        'NAV_CORP_LIST':'Corp List',
        'NAV_CORP_DETAIL':'Corp Detail',

        'NAV_NOTICE_CREATE':'New Notice',
        'NAV_NOTICE':'Notice',
        'NAV_NOTICE_LIST':'Notice List',
        'NAV_NOTICE_DETAIL':'Notice Detail',

        'NAV_INQUIRY':'Inquiry',
        'NAV_INQUIRY_LIST':'Inquiry List',
        'NAV_INQUIRY_DETAIL':'Inquiry Detail',

        'NAV_ACCOUNT_DETAIL':'Account',

        'NAV_SERVICES':'Services & Products',
        'NAV_TRIP_POST_LIST':'Trip Post List',
        'NAV_TRIP_POST_DETAIL':'Trip Post Detail',
        'NAV_TRIP_POST_EDIT':'Trip Post Edit',
        'NAV_TRIP_POST_CREATE':'Trip Post Create',


        'ADMIN_PROFILE_DESC':'Administrator',
        'LOGOUT':'Logout',
        'ADD':'추가하기',
        'EDIT':'수정하기',
        'UPDATE':'업데이트',

        'SIGNUP_REQUESTS':'Signup requests',

        'USER':'User',
        'APP_SESSIONS':'Mobile App Sessions',
        'BACK':'BACK',
        'SIGNOUT_REQUESTS':'Signout requests',
        'ACTIVITIES':'Activities',

        'SIGNUP_REQUEST_LIST':'Signup Request List',
        'SIGNUP_EMAIL_SENT':'Signup email has been sent.',

        'SUBMIT':'SUBMIT',
        'CREATE':'CREATE',
        'INVALID_CORP_CODE_FORMAT':'기업 코드 형식에 오류가 있습니다.',
        'CORP_CODE_IS_REQUIRED':'기업 코드를 입력하시기 바랍니다.',
        'INVALID_EMAIL_FORMAT':'이메일 형식에 오류가 있습니다.',
        'EMAIL_IS_REQUIRED':'이메일을 입력하시기 바랍니다.',
        'PASSWORD_IS_REQUIRED':'패스워드를 입력하시기 바랍니다.',
        'INVALID_PASSWORD_FORMAT':'패스워드는 6자 이상, 40자 이하로 입력하시기 바랍니다.',
        'CORP_ADMIN_USER_LOGIN':'기업 회원 관리자 로그인',
        'CORP_CODE':'기업 코드',
        'EMAIL':'이메일',
        'PASSWORD':'패스워드',
        'LOGIN':'로그인',
        'FORGOT_PASSWORD':'패스워드를 잊으셨나요?',
        'FORGOT_CORP_CODE':'기업 코드를 잊으셨나요?',
        'CONFIRM':'확인',
        'PAGE_NOT_FOUND':'요청하신 페이지가 없습니다.',

        'DASHBOARD':'대시보드',
        'INVALID_EMAIL_FORMAT':'invalid_email_format',
    },

};

export default UIString;